import { render, staticRenderFns } from "./ShowCategoryInfo.vue?vue&type=template&id=019a7a85&scoped=true&"
import script from "./ShowCategoryInfo.vue?vue&type=script&lang=js&"
export * from "./ShowCategoryInfo.vue?vue&type=script&lang=js&"
import style0 from "./ShowCategoryInfo.vue?vue&type=style&index=0&id=019a7a85&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "019a7a85",
  null
  
)

export default component.exports